<template>
    <div class="app-container1">
    <div id="base" class="">

     

      <!-- Unnamed (Rectangle) -->
      <div id="u1574" class="ax_default box_1">
        <div id="u1574_div" class=""></div>
        <div id="u1574_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u1575" class="ax_default box_1">
        <div id="u1575_div" class=""></div>
        <div id="u1575_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u1576" class="ax_default" data-left="275" data-top="220" data-width="530" data-height="134">

        <!-- Unnamed (Rectangle) -->
        <div id="u1577" class="ax_default box_1">
          <div id="u1577_div" class=""></div>
             <div id="u15772" class="innerbox" >
             <!-- for循环展示区域详情信息 -->
           
<table style="border-collapse:collapse;border-spacing: 0;" cellspacing="0" cellpadding="0">

<template v-for="item in quotaLevel2VO.arealist">

  <tr style="height:18px"> 
      <td align="left" width="180"><span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;{{item.area}}</span></td>   
      <td align="left" width="70"><span style="font-size:14px;">总费用</span></td>     
      <td align="left" width="70"><span style="font-size:14px;">{{item.actural}}元</span></td>     
  </tr>
 
  <tr style="height:18px">  
    <td colspan="3"></td>
  </tr>
</template>

 </table>


           </div>
        </div>

        <!-- Unnamed (Group) -->

        <!-- Unnamed (Line) -->
        <div id="u1582" class="ax_default line">
          <img id="u1582_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
          <div id="u1582_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1583" class="ax_default label">
          <div id="u1583_div" class=""></div>
          <div id="u1583_text" class="text ">
            <p><span>区域年度热力费</span></p>
          </div>
        </div>

        <!-- Unnamed (Group) -->


        <!-- Unnamed (Rectangle) 
        <div id="u1588" class="ax_default label">
          <div id="u1588_div" class=""></div>
          <div id="u1588_text" class="text ">
            <p><span>占比40%</span></p>
          </div>
        </div>

     
        <div id="u1589" class="ax_default label">
          <div id="u1589_div" class=""></div>
          <div id="u1589_text" class="text ">
            <p><span>占比60%</span></p>
          </div>
        </div>
        -->
      </div>

      <!-- Unnamed (Group) -->
      <div id="u1590" class="ax_default" data-left="572" data-top="179" data-width="500" data-height="23">

        <!-- Unnamed (Rectangle) -->
        <div id="u1591" class="ax_default label">
          <div id="u1591_div" class=""></div>
          <div id="u1591_text" class="text ">
            <p><span style="font-family:'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;font-weight:700;">{{this.energyfeeLevel1VO.hotYear}}</span><span style="font-family:'PingFangSC-Medium', 'PingFang SC Medium', 'PingFang SC', sans-serif;font-weight:500;">元</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1592" class="ax_default label">
          <div id="u1592_div" class=""></div>
          <div id="u1592_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1593" class="ax_default label">
          <div id="u1593_div" class=""></div>
          <div id="u1593_text" class="text ">
            <p><span>总费用</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1594" class="ax_default label">
          <div id="u1594_div" class=""></div>
          <div id="u1594_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1595" class="ax_default label">
          <div id="u1595_div" class=""></div>
          <div id="u1595_text" class="text ">
            <p><span style="font-family:'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;font-weight:700;">{{this.energyfeeLevel1VO.hotChangeYear}}</span><span style="font-family:'PingFangSC-Medium', 'PingFang SC Medium', 'PingFang SC', sans-serif;font-weight:500;">元</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1596" class="ax_default label">
          <div id="u1596_div" class=""></div>
          <div id="u1596_text" class="text ">
            <p><span>{{this.energyfeeLevel1VO.hotChangeRateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u1597" class="ax_default image">
          <img id="u1597_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u1597_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u1598" class="ax_default image">
          <img id="u1598_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u1598_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>



      <!-- Unnamed (Group) 
      <div id="u1600" class="ax_default" data-left="845" data-top="219" data-width="532" data-height="134">

       
        <div id="u1601" class="ax_default box_1">
          <div id="u1601_div" class=""></div>
             <div id="u15772" class="innerbox" >
             
           
<table style="border-collapse:collapse;border-spacing: 0;" cellspacing="0" cellpadding="0">

<template v-for="item in quotaLevel2VO.arealist">

  <tr style="height:18px"> 
      <td align="left" width="180"><span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;{{item.area}}</span></td>   
      <td align="left" width="70"><span style="font-size:14px;">总费用</span></td>     
      <td align="left" width="70"><span style="font-size:14px;">{{item.forecast}}元</span></td>     
  </tr>
 
  <tr style="height:18px">  
    <td colspan="3"></td>
  </tr>
</template>

 </table>


           </div>
        </div>

       
        <div id="u1602" class="ax_default label">
          <div id="u1602_div" class=""></div>
          <div id="u1602_text" class="text ">
            <p><span>区域下一年度热力费预测</span></p>
          </div>
        </div>

     
        <div id="u1603" class="ax_default line">
          <img id="u1603_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
          <div id="u1603_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>


        <div id="u1604" class="ax_default" data-left="881" data-top="271" data-width="303" data-height="20">

        

          

        </div>

    
        <div id="u1608" class="ax_default" data-left="881" data-top="309" data-width="303" data-height="20">

         
       

        
        </div>
      </div>
-->
      <!-- Unnamed (Group) -->
      <div id="u1612" class="ax_default" data-left="258" data-top="436" data-width="1152" data-height="285">

        <!-- Unnamed (Rectangle) -->
        <div id="u1613" class="ax_default label">
          <div id="u1613_div" class=""></div>
          <div id="u1613_text" class="text ">
            <p><span>费用详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1614" class="ax_default box_1">
          <div id="u1614_div" class=""></div>
          <div id="u1614_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

      
     <div id="u7733" class="ax_default label">
        <div id="u7733_div" class=""></div>
        <div id="u7733_text" class="text ">
          <p><span>项目</span></p>
        </div>
      </div>
 <!-- Unnamed (Droplist) -->
      <div id="u7743" class="ax_default droplist">
        <div id="u7743_div" class=""></div>
        <!--
        <select id="u774_input" class="u774_input" v-model="queryParams.area">
          <option class="u774_input_option" selected value="">全部</option>
          <option class="u774_input_option" value="一期">一期</option>
          <option class="u774_input_option" value="二期">二期</option>
        </select>
        -->
          <el-select  @change="changeProject" clearable v-model="queryParams.projectId"  placeholder="选择项目">
                                            <el-option
                                                    v-for="item in projectList"
                                                    :label="item.projectName"
                                                    :value="item.projectId"
                                                    :key="item.projectId">
                                            </el-option>
                    </el-select>
      </div>
        <!-- Unnamed (Rectangle) -->
        <div id="u1615" class="ax_default label">
          <div id="u1615_div" class=""></div>
          <div id="u1615_text" class="text ">
            <p><span>区域</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u1616" class="ax_default droplist">
           <tree-select
                                    v-model="queryParams.positionId"
                                    @select="selectPosition"
                                    :disable-branch-nodes="false"
                                    :multiple="false"
                                    :show-count="true"
                                    :flat="true"
                               
                                    :autoFocus="true"
                                    :placeholder="$t('commons.selectPlease')"
                                    :options="positionList" />
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1617" class="ax_default label">
          <div id="u1617_div" class=""></div>
          <div id="u1617_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u1618" class="ax_default image">
           <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              value-format="yyyy-MM-dd HH:mm:ss"
               v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                   @change="setDateRange"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
          <div id="u1618_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1619" class="ax_default primary_button" @click="handleQuery">
          <div id="u1619_div" class=""></div>
          <div id="u1619_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1620" class="ax_default box_1">
          <div id="u1620_div" class=""></div>
          <div id="u1620_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1621" class="ax_default heading_1">
          <div id="u1621_div" class=""></div>
          <div id="u1621_text" class="text ">
            <p><span>时间</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1622" class="ax_default heading_1">
          <div id="u1622_div" class=""></div>
          <div id="u1622_text" class="text ">
            <p><span>费用类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
      

        <!-- Unnamed (Rectangle) -->
        <div id="u1624" class="ax_default primary_button">
          <div id="u1624_div" class=""></div>
          <div id="u1624_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u1625" class="ax_default label">
        <div class="innerbox"  style="width: 100%; height:350px;position: absolute;z-index: 99;">
          <el-table  :data="consumptionList"  v-loading="loading"
                style="width: 100%;"
                 show-header="false"
                >
               
                <el-table-column label="时间" align="center" prop="energyMonth" />
              <el-table-column label="区域" align="center" prop="area" />
 
                <el-table-column label="费用" align="center" prop="energyfee" />
             
               
             </el-table>
               <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>

        <!-- Unnamed (Rectangle) 
        <div id="u1626" class="ax_default label">
          <div id="u1626_div" class=""></div>
          <div id="u1626_text" class="text ">
            <p><span>分项</span></p>
          </div>
        </div>

        
        <div id="u1627" class="ax_default droplist disabled">
          <div id="u1627_div" class="disabled"></div>
          <select id="u1627_input" class="u1627_input" disabled>
            <option class="u1627_input_option" selected value="全部">全部</option>
            <option class="u1627_input_option" value="冷暖空调">冷暖空调</option>
            <option class="u1627_input_option" value="照明插座">照明插座</option>
            <option class="u1627_input_option" value="动力设备">动力设备</option>
            <option class="u1627_input_option" value="特殊用电">特殊用电</option>
          </select>
        </div>

        
        <div id="u1628" class="ax_default label">
          <div id="u1628_div" class=""></div>
          <div id="u1628_text" class="text ">
            <p><span>费用类型</span></p>
          </div>
        </div>

     
        <div id="u1629" class="ax_default droplist">
          <div id="u1629_div" class=""></div>
          <select id="u1629_input" class="u1629_input">
            <option class="u1629_input_option" selected value="请选择">请选择</option>
            <option class="u1629_input_option" value="电费">电费</option>
            <option class="u1629_input_option" value="水费">水费</option>
            <option class="u1629_input_option" value="燃气费">燃气费</option>
            <option class="u1629_input_option" value="热力费">热力费</option>
            <option class="u1629_input_option" value="其他能源费用">其他能源费用</option>
          </select>
        </div>
-->
        <!-- Unnamed (Rectangle) 
        <div id="u1630" class="ax_default heading_1">
          <div id="u1630_div" class=""></div>
          <div id="u1630_text" class="text ">
            <p><span>区域</span></p>
          </div>
        </div>

    
        <div id="u1631" class="ax_default heading_1">
          <div id="u1631_div" class=""></div>
          <div id="u1631_text" class="text ">
            <p><span>分项</span></p>
          </div>
        </div>

    
        <div id="u1632" class="ax_default heading_1">
          <div id="u1632_div" class=""></div>
          <div id="u1632_text" class="text ">
            <p><span>费用</span></p>
          </div>
        </div>
        -->
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u1633" class="ax_default button" @click="routerurl(1)">
        <div id="u1633_div" class=""></div>
        <div id="u1633_text" class="text ">
          <p><span>电费</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u1634" class="ax_default button" @click="routerurl(2)">
        <div id="u1634_div" class=""></div>
        <div id="u1634_text" class="text ">
          <p><span>水费</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u1635" class="ax_default line">
        <img id="u1635_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u1635_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u1636" class="ax_default button" @click="routerurl(3)">
        <div id="u1636_div" class=""></div>
        <div id="u1636_text" class="text ">
          <p><span>天然气费</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u1637" class="ax_default button" @click="routerurl(4)">
        <div id="u1637_div" class=""></div>
        <div id="u1637_text" class="text ">
          <p><span>热力费</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u1638" class="ax_default button" @click="routerurl(5)">
        <div id="u1638_div" class=""></div>
        <div id="u1638_text" class="text ">
          <p><span>其他费用</span></p>
        </div>
      </div>

   
    </div>
    </div>
    
 

</template>
<script>
import "echarts/theme/macarons";
import {
  getLevel1,//总汇总
  listLevel1,//总查询列表
  getPowerLevel2,//电
  listPower,//电
  getWaterLevel2,//水
  listWater,// 水
  getGasLevel2,//气
  listGas,//气
  getHotLevel2,//热
  listHot,//热
  getOthersLevel2,//其他
  listOthers,//其他
} from "@/api/business/energy/energyfee";
import {
  getEnergyFeeLevel1,//总汇总

} from "@/api/business/energy/energyfee";
import{
        getProjectList
    }from '@/api/business/base/tenant/project';
    import {      
        getPositionTree
    } from '@/api/business/base/tenant/device';
     import {listToTree} from '@/utils/tree';
    import TreeSelect from '@riophae/vue-treeselect';   
        import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
     components: {Pagination,TreeSelect},
  data() {
    return {
           // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
      consumptionList: [],
         projectList:[],
           positionList:[],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
       queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   area: '',
              
                   childEnergyType: '',
                  areaid: null,
                 positionId : null,
                   projectId: null,
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
      energyTypeList: [
        { itemCode: 1, itemName: "空调用电" },
        { itemCode: 2, itemName: "照明用电" },
        { itemCode: 3, itemName: "东力用电" },
        { itemCode: 4, itemName: "特殊用电" },
      ],
      areaTypeList: [
        { itemCode: 1, itemName: "一区" },
        { itemCode: 2, itemName: "二区" },
        { itemCode: 3, itemName: "三区" },
        { itemCode: 4, itemName: "四区" },
      ],
      buildingTypeList: [
        { itemCode: 1, itemName: "1号楼" },
        { itemCode: 2, itemName: "2号楼" },
        { itemCode: 3, itemName: "3号楼" },
        { itemCode: 4, itemName: "4号楼" },
      ],
      unitTypeList: [
        { itemCode: 1, itemName: "1单元" },
        { itemCode: 2, itemName: "2单元" },
        { itemCode: 3, itemName: "3单元" },
        { itemCode: 4, itemName: "4单元" },
      ],
      

        
          yearlyProportionOptionsArea: null,
          yearlyProportionOptionsType: null,
        
           //接收总统计数据的对象
        quotaLevel2VO: {
          arealist: [],

          airpercent: "",
          lightpercent: "",
          powerpercent: "",
          specialpercent: "",
          tapwaterpercent: "",
          reclaimedwaterpercent: "",

          airconditionactural: "",
          airconditionforeast: "",
 
          lightactural: "",
          lightforeast: "",

          poweractural: "",
          powerforeast: "",

          specialractural: "",
          specialforeast: "",

          wateractural: "",
          waterforeast: "",

          gasactural: "",
          gasforeast: "",

          hotactural: "",
          hotforeast: "",

          othersactural: "",
          othersforeast: "",

          tapwateractural: "",
          tapwaterforecast: "",

          reclaimedwateractural: "",
          reclaimedwaterforecast: "",
        },
                //接收总统计数据的对象
        energyfeeLevel1VO: {
            //----------汇总数据-------------
    //今年总费
    powerYear: "",//1
    waterYear: "",//2
    gasYear: "",//3
    hotYear: "",//4
    othersYear: "",//5
    totalYear: "",//0

    //---今年用费变化
    powerChangeYear: "",
    waterChangeYear: "",
    gasChangeYear: "",
    hotChangeYear: "",
    othersChangeYear: "",
    totalChangeYear: "",

    //---今年用费变化率
    powerChangeRateYear: "",
    waterChangeRateYear: "",
    gasChangeRateYear: "",
    hotChangeRateYear: "",
    otherschangeRateYear: "",
    totalChangeRateYear: "",

    //--下一周期预测
    powerForecastYear: "",
    waterForecastYear: "",
    gasForecastYear: "",
    hotForecastYear: "",
    othersForecastYear: "",
    totalForecastYear: "",
    //----------------总能源费-----------------------------
    //电季总费
    totalSeason1: "",
    totalSeason2: "",
    totalSeason3: "",
    totalSeason4: "",


    //---季度用费变化
    totalChangeSeason1: "",
    totalChangeSeason2: "",
    totalChangeSeason3: "",
    totalChangeSeason4: "",

    //---季用电费变化率
    totalChangeRateSeason1: "",
    totalChangeRateSeason2: "",
    totalChangeRateSeason3: "",
    totalChangeRateSeason4: "",

    //--季下一周期预测
    totalForecastSeason1: "",
    totalForecastSeason2: "",
    totalForecastSeason3: "",
    totalForecastSeason4: "",

    //----------------电-----------------------------
    //电季总费
    powerSeason1: "",
    powerSeason2: "",
    powerSeason3: "",
    powerSeason4: "",


    //---季度用费变化
    powerChangeSeason1: "",
    powerChangeSeason2: "",
    powerChangeSeason3: "",
    powerChangeSeason4: "",

    //---季用电费变化率
    powerChangeRateSeason1: "",
    powerChangeRateSeason2: "",
    powerChangeRateSeason3: "",
    powerChangeRateSeason4: "",
    
    //--季下一周期预测
    powerForecastSeason1: "",
    powerForecastSeason2: "",
    powerForecastSeason3: "",
    powerForecastSeason4: "",


    //---------------水----------------------------------------

    //水季总费
    waterSeason1: "",
    waterSeason2: "",
    waterSeason3: "",
    waterSeason4: "",
    //---季度用费变化
    waterChangeSeason1: "",
    waterChangeSeason2: "",
    waterChangeSeason3: "",
    waterChangeSeason4: "",

    //---季用水费变化率
    waterChangeRateSeason1: "",
    waterChangeRateSeason2: "",
    waterChangeRateSeason3: "",
    waterChangeRateSeason4: "",
   
    //--水季下一周期预测
    waterForecastSeason1: "",
    waterForecastSeason2: "",
    waterForecastSeason3: "",
    waterForecastSeason4: "",

    //--------------气--------------------------------------
    //气季总费
    gasSeason1: "",
    gasSeason2: "",
    gasSeason3: "",
    gasSeason4: "",
    //---季度用费变化
    gasChangeSeason1: "",
    gasChangeSeason2: "",
    gasChangeSeason3: "",
    gasChangeSeason4: "",
    //---季用水费变化率
    gasChangeRateSeason1: "",
    gasChangeRateSeason2: "",
    gasChangeRateSeason3: "",
    gasChangeRateSeason4: "",

    //--水季下一周期预测
    gasForecastSeason1: "",
    gasForecastSeason2: "",
    gasForecastSeason3: "",
    gasForecastSeason4: "",

    //--------------热-----------------------------
    //热季总费
    hotSeason1: "",
    hotSeason2: "",
    hotSeason3: "",
    hotSeason4: "",
    //---季度用费变化
    hotChangeSeason1: "",
    hotChangeSeason2: "",
    hotChangeSeason3: "",
    hotChangeSeason4: "",
    //---季用水费变化率
    hotChangeRateSeason1: "",
    hotChangeRateSeason2: "",
    hotChangeRateSeason3: "",
    hotChangeRateSeason4: "",

    //--水季下一周期预测
    hotForecastSeason1: "",
    hotForecastSeason2: "",
    hotForecastSeason3: "",
    hotForecastSeason4: "",
    //----------------总能源费-----------------------------
    //电季总费
    othersSeason1: "",
    othersSeason2: "",
    othersSeason3: "",
    othersSeason4: "",


    //---季度用费变化
    othersChangeSeason1: "",
    othersChangeSeason2: "",
    othersChangeSeason3: "",
    othersChangeSeason4: "",

    //---季用电费变化率
    othersChangeRateSeason1: "",
    othersChangeRateSeason2: "",
    othersChangeRateSeason3: "",
    othersChangeRateSeason4: "",

    //--季下一周期预测
    othersForecastSeason1: "",
    othersForecastSeason2: "",
    othersForecastSeason3: "",
    othersForecastSeason4: "",
   //---------------总月能源费----
   //总能源费总费
   totalMonth1: "",
    totalMonth2: "",
    totalMonth3: "",
    totalMonth4: "",
    totalMonth5: "",
    totalMonth6: "",
    totalMonth7: "",
    totalMonth8: "",
    totalMonth9: "",
    totalMonth10: "",
    totalMonth11: "",
    totalMonth12: "",

    //总能源费变化
    totalChangeMonth1: "",
    totalChangeMonth2: "",
    totalChangeMonth3: "",
    totalChangeMonth4: "",
    totalChangeMonth5: "",
    totalChangeMonth6: "",
    totalChangeMonth7: "",
    totalChangeMonth8: "",
    totalChangeMonth9: "",
    totalChangeMonth10: "",
    totalChangeMonth11: "",
    totalChangeMonth12: "",
    //---总能源费变化率
    totalChangeRateMonth1: "",
    totalChangeRateMonth2: "",
    totalChangeRateMonth3: "",
    totalChangeRateMonth4: "",
    totalChangeRateMonth5: "",
    totalChangeRateMonth6: "",
    totalChangeRateMonth7: "",
    totalChangeRateMonth8: "",
    totalChangeRateMonth9: "",
    totalChangeRateMonth10: "",
    totalChangeRateMonth11: "",
    totalChangeRateMonth12: "",


    //--总能源费下一周期预测
    totalForecastMonth1: "",
    totalForecastMonth2: "",
    totalForecastMonth3: "",
    totalForecastMonth4: "",
    totalForecastMonth5: "",
    totalForecastMonth6: "",
    totalForecastMonth7: "",
    totalForecastMonth8: "",
    totalForecastMonth9: "",
    totalForecastMonth10: "",
    totalForecastMonth11: "",
    totalForecastMonth12: "",

    //-------------月电费----------------------------
    //电月总费
    powerMonth1: "",
    powerMonth2: "",
    powerMonth3: "",
    powerMonth4: "",
    powerMonth5: "",
    powerMonth6: "",
    powerMonth7: "",
    powerMonth8: "",
    powerMonth9: "",
    powerMonth10: "",
    powerMonth11: "",
    powerMonth12: "",

    //电月变化
    powerChangeMonth1: "",
    powerChangeMonth2: "",
    powerChangeMonth3: "",
    powerChangeMonth4: "",
    powerChangeMonth5: "",
    powerChangeMonth6: "",
    powerChangeMonth7: "",
    powerChangeMonth8: "",
    powerChangeMonth9: "",
    powerChangeMonth10: "",
    powerChangeMonth11: "",
    powerChangeMonth12: "",
    //---月用电费变化率
    powerChangeRateMonth1: "",
    powerChangeRateMonth2: "",
    powerChangeRateMonth3: "",
    powerChangeRateMonth4: "",
    powerChangeRateMonth5: "",
    powerChangeRateMonth6: "",
    powerChangeRateMonth7: "",
    powerChangeRateMonth8: "",
    powerChangeRateMonth9: "",
    powerChangeRateMonth10: "",
    powerChangeRateMonth11: "",
    powerChangeRateMonth12: "",


    //--月用电费下一周期预测
    powerForecastMonth1: "",
    powerForecastMonth2: "",
    powerForecastMonth3: "",
    powerForecastMonth4: "",
    powerForecastMonth5: "",
    powerForecastMonth6: "",
    powerForecastMonth7: "",
    powerForecastMonth8: "",
    powerForecastMonth9: "",
    powerForecastMonth10: "",
    powerForecastMonth11: "",
    powerForecastMonth12: "",
    //--------------------
    //水月总费
    waterMonth1: "",
    waterMonth2: "",
    waterMonth3: "",
    waterMonth4: "",
    waterMonth5: "",
    waterMonth6: "",
    waterMonth7: "",
    waterMonth8: "",
    waterMonth9: "",
    waterMonth10: "",
    waterMonth11: "",
    waterMonth12: "",
    //水月变化
    waterChangeMonth1: "",
    waterChangeMonth2: "",
    waterChangeMonth3: "",
    waterChangeMonth4: "",
    waterChangeMonth5: "",
    waterChangeMonth6: "",
    waterChangeMonth7: "",
    waterChangeMonth8: "",
    waterChangeMonth9: "",
    waterChangeMonth10: "",
    waterChangeMonth11: "",
    waterChangeMonth12: "",
    //---月用电费变化率
    waterChangeRateMonth1: "",
    waterChangeRateMonth2: "",
    waterChangeRateMonth3: "",
    waterChangeRateMonth4: "",
    waterChangeRateMonth5: "",
    waterChangeRateMonth6: "",
    waterChangeRateMonth7: "",
    waterChangeRateMonth8: "",
    waterChangeRateMonth9: "",
    waterChangeRateMonth10: "",
    waterChangeRateMonth11: "",
    waterChangeRateMonth12: "",

    //--月用电费下一周期预测
    waterForecastMonth1: "",
    waterForecastMonth2: "",
    waterForecastMonth3: "",
    waterForecastMonth4: "",
    waterForecastMonth5: "",
    waterForecastMonth6: "",
    waterForecastMonth7: "",
    waterForecastMonth8: "",
    waterForecastMonth9: "",
    waterForecastMonth10: "",
    waterForecastMonth11: "",
    waterForecastMonth12: "",
    //气月总费
    gasMonth1: "",
    gasMonth2: "",
    gasMonth3: "",
    gasMonth4: "",
    gasMonth5: "",
    gasMonth6: "",
    gasMonth7: "",
    gasMonth8: "",
    gasMonth9: "",
    gasMonth10: "",
    gasMonth11: "",
    gasMonth12: "",
    //气月变化
    gasChangeMonth1: "",
    gasChangeMonth2: "",
    gasChangeMonth3: "",
    gasChangeMonth4: "",
    gasChangeMonth5: "",
    gasChangeMonth6: "",
    gasChangeMonth7: "",
    gasChangeMonth8: "",
    gasChangeMonth9: "",
    gasChangeMonth10: "",
    gasChangeMonth11: "",
    gasChangeMonth12: "",
    //---月用电费变化率
    gasChangeRateMonth1: "",
    gasChangeRateMonth2: "",
    gasChangeRateMonth3: "",
    gasChangeRateMonth4: "",
    gasChangeRateMonth5: "",
    gasChangeRateMonth6: "",
    gasChangeRateMonth7: "",
    gasChangeRateMonth8: "",
    gasChangeRateMonth9: "",
    gasChangeRateMonth10: "",
    gasChangeRateMonth11: "",
    gasChangeRateMonth12: "",

    //--月用电费下一周期预测
    gasForecastMonth1: "",
    gasForecastMonth2: "",
    gasForecastMonth3: "",
    gasForecastMonth4: "",
    gasForecastMonth5: "",
    gasForecastMonth6: "",
    gasForecastMonth7: "",
    gasForecastMonth8: "",
    gasForecastMonth9: "",
    gasForecastMonth10: "",
    gasForecastMonth11: "",
    gasForecastMonth12: "",

    //热月总费
    hotMonth1: "",
    hotMonth2: "",
    hotMonth3: "",
    hotMonth4: "",
    hotMonth5: "",
    hotMonth6: "",
    hotMonth7: "",
    hotMonth8: "",
    hotMonth9: "",
    hotMonth10: "",
    hotMonth11: "",
    hotMonth12: "",
    //热月变化
    hotChangeMonth1: "",
    hotChangeMonth2: "",
    hotChangeMonth3: "",
    hotChangeMonth4: "",
    hotChangeMonth5: "",
    hotChangeMonth6: "",
    hotChangeMonth7: "",
    hotChangeMonth8: "",
    hotChangeMonth9: "",
    hotChangeMonth10: "",
    hotChangeMonth11: "",
    hotChangeMonth12: "",
    //---月用电费变化率
    hotChangeRateMonth1: "",
    hotChangeRateMonth2: "",
    hotChangeRateMonth3: "",
    hotChangeRateMonth4: "",
    hotChangeRateMonth5: "",
    hotChangeRateMonth6: "",
    hotChangeRateMonth7: "",
    hotChangeRateMonth8: "",
    hotChangeRateMonth9: "",
    hotChangeRateMonth10: "",
    hotChangeRateMonth11: "",
    hotChangeRateMonth12: "",


    //--月用电费下一周期预测
    hotForecastMonth1: "",
    hotForecastMonth2: "",
    hotForecastMonth3: "",
    hotForecastMonth4: "",
    hotForecastMonth5: "",
    hotForecastMonth6: "",
    hotForecastMonth7: "",
    hotForecastMonth8: "",
    hotForecastMonth9: "",
    hotForecastMonth10: "",
    hotForecastMonth11: "",
    hotForecastMonth12: "",
  //------其他能源费----

  othersMonth1: "",
    othersMonth2: "",
    othersMonth3: "",
    othersMonth4: "",
    othersMonth5: "",
    othersMonth6: "",
    othersMonth7: "",
    othersMonth8: "",
    othersMonth9: "",
    othersMonth10: "",
    othersMonth11: "",
    othersMonth12: "",

    //其他能源费月变化
    othersChangeMonth1: "",
    othersChangeMonth2: "",
    othersChangeMonth3: "",
    othersChangeMonth4: "",
    othersChangeMonth5: "",
    othersChangeMonth6: "",
    othersChangeMonth7: "",
    othersChangeMonth8: "",
    othersChangeMonth9: "",
    othersChangeMonth10: "",
    othersChangeMonth11: "",
    othersChangeMonth12: "",
    //---其他能源费费变化率
    othersChangeRateMonth1: "",
    othersChangeRateMonth2: "",
    othersChangeRateMonth3: "",
    othersChangeRateMonth4: "",
    othersChangeRateMonth5: "",
    othersChangeRateMonth6: "",
    othersChangeRateMonth7: "",
    othersChangeRateMonth8: "",
    othersChangeRateMonth9: "",
    othersChangeRateMonth10: "",
    othersChangeRateMonth11: "",
    othersChangeRateMonth12: "",


    //--其他能源费电费下一周期预测
    othersForecastMonth1: "",
    othersForecastMonth2: "",
    othersForecastMonth3: "",
    othersForecastMonth4: "",
    othersForecastMonth5: "",
    othersForecastMonth6: "",
    othersForecastMonth7: "",
    othersForecastMonth8: "",
    othersForecastMonth9: "",
    othersForecastMonth10: "",
    othersForecastMonth11: "",
    othersForecastMonth12: "",
        }


    };
  },
    created() {
       getEnergyFeeLevel1(this.queryParams).then((response) => {
           //alert("11111");
          this.energyfeeLevel1VO = response.data;
        
    });

    getHotLevel2(this.queryParams).then((response) => {
        
          this.quotaLevel2VO = response.data;
          if(this.energyfeeLevel1VO.waterYear!=null &&this.energyfeeLevel1VO.waterYear!=0){
            if(this.quotaLevel2VO.tapwateractural!=null){
               this.quotaLevel2VO.tapwaterpercent=(this.quotaLevel2VO.tapwateractural/this.energyfeeLevel1VO.waterYear * 100).toFixed(2);
              
            } 
             if(this.quotaLevel2VO.reclaimedwateractural!=null){
               this.quotaLevel2VO.reclaimedwaterpercent=(this.quotaLevel2VO.reclaimedwateractural/this.energyfeeLevel1VO.waterYear * 100).toFixed(2);
            } 
            
          }
      
      });

       this.getProjectList(141);
        
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
        //----------------位置选择----------------------------
             selectPosition(node){
                this.queryParams.positionId = node.positionId;
                //alert(this.listQuery.positionId);
               },
                
           
            getProjectList(companyId){
             // alert(companyId);
                getProjectList({"companyId":companyId}).then(res=>{
                    this.projectList = res;
                    //alert(this.projectList.length);
                })
                
            },
           changeProject() {
                // alert(this.queryParams.projectId);
                if(this.queryParams.projectId == ''){
                    this.queryParams.projectId = null;
                    this.queryParams.positionId = null;
                    this.positionList = [];
                }else{                   
                   getPositionTree({"projectId":this.queryParams.projectId}).then(response =>{
                     
                      // alert(this.queryParams.projectId);
                        this.queryParams.positionId = null;
                        this.positionList = [];
                        let data = listToTree(response,"positionId","parentId");
                        this.recursivePosition(data)
                    });
                }
            },
            //递归位置列表修改属性及数据结构
            recursivePosition(row){
                let data = row.map(v => {
                    v.label = v.positionName;
                    v.id = v.positionId;
                    if(v.children != undefined){
                        this.recursivePosition(v.children);
                    }
                    return v
                })
                //alert(this.queryParams.projectId);
                this.positionList = data;
            },
          
           

    //----------------------------------------------   
           routerurl(flag){
         switch(flag){
           case 1:
              this.$router.push('/energyfee/level2/power/index');
             break;
           case 2:
              this.$router.push('/energyfee/level2/water/index');
              break;
             
           case 3:
              this.$router.push('/energyfee/level2/gas/index');
             break;
           case 4:
              this.$router.push('/energyfee/level2/hot/index');
             break;
          case 5:
              this.$router.push('/energyfee/level2/others/index');
             break;   
         }
     },
       /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;

      listHot(this.queryParams).then((response) => {
     
        for(var i=0;i<response.rows.length;i++){
        
            if(response.rows[i].childEnergyType==1){
               //response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
               response.rows[i].energyMonth=response.rows[i].energyMonth+'月';
              // response.rows[i].childEnergyType='冷暖空调';
            }
            if(response.rows[i].childEnergyType==2){
             // response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              response.rows[i].energyMonth=response.rows[i].energyMonth+'月';
              // response.rows[i].childEnergyType='照明插座';
              }
              if(response.rows[i].childEnergyType==3){
              // response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              response.rows[i].energyMonth=response.rows[i].energyMonth+'月';
            //   response.rows[i].childEnergyType='动力设备';
            }
            
            if(response.rows[i].childEnergyType==4){
              //response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              response.rows[i].energyMonth=response.rows[i].energyMonth+'月';
              // response.rows[i].childEnergyType='特殊用电';
            }
           
        }
      
        this.consumptionList = response.rows;
         // alert(this.consumptionlist.length);
        this.total = response.total;
        this.loading = false;
      });
    },
   }
}
</script>
<style scoped src="../../../../../../assets/common/energyfee/css/hot/styles.css"></style>
<style scoped src="../../../../../../assets/common/consumption/css/styles.css"></style>
<style scoped src="../../../../../../assets/common/rp_page.css"></style>
<style scoped>
       .app-container1 {
  margin: 0px;
  
  background-color: rgba(243, 247, 255, 1);
  border-radius: 5px;
  min-height: calc(100vh + 900px);
  
}
.pagination-container {
  background: rgba(255, 255, 255, 0.0235294117647059);
  padding: 18px 0px;
  float: left;
  z-index: 99;
position: absolute;
}
 .innerbox{
            overflow-x: hidden;
            overflow-y: auto;       
        }
        /*滚动条样式*/
   .innerbox::-webkit-scrollbar {
           	width: 8px;
            height: 8px;
            background-color: #F5F5F5;
    }
    .innerbox::-webkit-scrollbar-thumb {
            	border-radius:3px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
    }
    .innerbox::-webkit-scrollbar-track {
          	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            border-radius: 3px;
            background-color: #F5F5F5;

    }
  .fontset{
      font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;
      font-weight:400;
      font-style:normal;
  }
</style>
